import { useApi, useToaster } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";

export function useDeleteExpertPlan() {
  const api = useApi();
  const toaster = useToaster();
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isPending, error } = useMutation({
    mutationKey: ["admin", "expert-plans", "delete"],
    mutationFn: (planId: number) => {
      return api.admin.expertSubscriptions.deletePlan({
        params: { plan: planId },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin", "expert-plans"] });
      toaster.create({
        title: "Plan deleted",
        type: "success",
      });
    },
    onError: (err: Error) => {
      toaster.create({
        title: "Failed to delete plan",
        description: err.message || "An unexpected error occurred",
        type: "error",
      });
      console.error("[useDeleteExpertPlan] Error:", err);
    },
  });

  return { mutate, mutateAsync, isPending, error };
}

export default useDeleteExpertPlan;
